function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  strong {\n    font-weight: bold;\n  }\n  em {\n    font-style: italic;\n  }\n\n  ul,\n  ol {\n    margin-top: 0;\n    padding-left: 0.5rem;\n    list-style-position: inside;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
/**
 * @param {{
 *   className?: string;
 *   html?: string;
 * }}
 */ export default function RichTextHtmlWrapper(param) {
    var className = param.className, html = param.html;
    return /*#__PURE__*/ _jsx(Wrapper, {
        "data-testid": "rich-text-wrapper",
        className: className,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
}
var Wrapper = styled.div(_templateObject());
